import { render, staticRenderFns } from "./ScreeningStage.vue?vue&type=template&id=5732a29a&scoped=true&"
import script from "./ScreeningStage.vue?vue&type=script&lang=js&"
export * from "./ScreeningStage.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningStage.vue?vue&type=style&index=0&id=5732a29a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732a29a",
  null
  
)

export default component.exports